import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const Sucesso = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-accent/10 via-background to-primary/5 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-xl text-center">
        <CardHeader>
          <div className="mx-auto mb-4 bg-accent/10 p-4 rounded-full w-fit">
            <CheckCircle className="h-12 w-12 text-accent" />
          </div>
          <CardTitle className="text-2xl text-accent">Pagamento Confirmado!</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            Seu pagamento foi processado com sucesso. Você receberá um comprovante por email.
          </p>
          <Link to="/">
            <Button className="w-full">Voltar ao Início</Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};

export default Sucesso;
